import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/commentsGroup.svg'
import { Actor } from './Actor'
import Avatar from 'common/Avatar/Avatar'
import {
  ActivityEventPosition,
  CommentsGroupEvent,
  RepliesGroupEvent,
  CommentableType,
  CommentsGroupComment,
} from './Types'
import { pluralize } from 'utils'
import { NestedActivityEvent } from './NestedActivityEvent'
import { useHistory } from 'react-router-dom'
import { COMMENT_VIEW, TASKS_VIEW } from 'components/DocRightRail/Constants'
import { ProseDisplay } from 'common/ProseInput/ProseDisplay'
import Styles from './CommentsGroup.module.scss'
interface Props extends ActivityEventPosition {
  event: CommentsGroupEvent | RepliesGroupEvent
}

const parseInlineMentions = (text: string): string => {
  const replacer = (_match: string, name: string, ..._args: any[]) => {
    return `@${name}`
  }

  return text.replace(/@\{\+\{\+\{(.+?)\}\+\}\+\}/g, replacer)
}

const CommentText = ({ comment }: { comment: CommentsGroupComment }) => {
  if (comment.html_comment)
    return <ProseDisplay className={Styles.body} html={comment.html_comment} />

  return <>{parseInlineMentions(comment.comment)}</>
}

const CommentsGroup = ({ event, ...props }: Props) => {
  const { commenters, data } = event
  const totalCommentsCount = data.length
  const history = useHistory()

  const handleClick = (
    e: MouseEvent,
    comment_id: number,
    commentable_type: CommentableType,
    commentable_id?: number,
  ) => {
    e.stopPropagation()
    switch (commentable_type) {
      case CommentableType.TODO:
        history.push({
          search: `right_rail=${TASKS_VIEW}&id=${commentable_id || ''}`,
        })
        break
      case CommentableType.COMMENT:
      default:
        history.push({
          search: `right_rail=${COMMENT_VIEW}&id=${comment_id}`,
        })
        break
    }
  }

  return (
    <BaseActivityEvent
      {...props}
      onClick={(e) => handleClick(e, data[0].comment_id, data[0].commentable_type, data[0].commentable_id)}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={
        <>
          <Actor
            count={commenters}
            displayName={data[0].user.display_name || 'Anonymous User'}
            userId={data[0]?.user?.id}
          />{' '}
          made {totalCommentsCount} {pluralize('comment', totalCommentsCount)}
        </>
      }
      message={totalCommentsCount === 1 && <CommentText comment={data[0]} />}
      nestedContent={
        totalCommentsCount > 1 &&
        data.map((comment) => {
          const { user, comment_id, commentable_id, commentable_type } = comment
          return (
            <NestedActivityEvent
              key={`${event.id}-${comment_id}`}
              avatar={<Avatar size={20} url={user.avatar} label={user.display_name || 'Anonymous User'} />}
              content={
                <>
                  <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> made 1 comment
                </>
              }
              message={<CommentText comment={comment} />}
              timestamp={comment.timestamp}
              onClick={(e) => handleClick(e, comment_id, commentable_type, commentable_id)}
            />
          )
        })
      }
    />
  )
}

export { CommentsGroup }
